import React from 'react';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFnsV3';
import { isValid } from 'date-fns';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';

import theme from 'config/theme';
import { enGB } from 'date-fns/locale';
import styles from './filterTime.style';

const FilterDateTime = ({
  value,
  name,
  error,
  onChange,
  label = '',
  is24hr = false,
  ...rest
}) => {
  const hasValue = value || value?.value;

  const handleChange = (newValue) => {
    if (newValue && newValue instanceof Date && isValid(newValue)) {
      onChange(newValue.toISOString());
    } else {
      onChange(newValue);
    }
  };

  const handleClear = (e) => {
    e.stopPropagation(); // σημαντικό για να μην ανοίγει το picker
    onChange(null);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
      <DateTimePicker
        showToolbar={false}
        format="dd-MM-yyyy HH:mm"
        ampm={!is24hr}
        slotProps={{
          popper: {
            sx: {
              ...styles.popper,
            },
          },

          textField: (params) => ({
            ...params,
            variant: 'outlined',
            error: !!error,
            sx: {
              ...styles.textfield,
              ...(hasValue && styles.textfieldWithValue),
            },
            InputProps: {
              ...params.InputProps,
              endAdornment: (
                // eslint-disable-next-line react/jsx-no-useless-fragment
                <>
                  {hasValue ? (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={handleClear}
                        aria-label="clear date"
                        sx={{
                          '&:hover': {
                            background: 'none',
                          },
                        }}
                      >
                        <ClearIcon
                          fontSize="small"
                          sx={{
                            width: '14px',
                            color: theme.palette.blues.primaryBlue,
                          }}
                        />
                      </IconButton>
                    </InputAdornment>
                  ) : (
                    params.InputProps?.endAdornment
                  )}
                </>
              ),
            },
          }),
        }}
        value={value ? new Date(value) : null}
        onChange={handleChange}
        {...rest}
        label={label}
      />
    </LocalizationProvider>
  );
};

export default FilterDateTime;
